// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedPromoCode: Object,
};

const DeleteTip = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedPromoCode,
  } = props;

  const DeleteSelectedItem = () => {
    submit(selectedPromoCode);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteSelectedItem} type="danger">Delete</SpButton>,
      ]}
      title="Delete Tips"
    >
      <div className="px-4">
        <div className="mt-1">Are you sure you want to delete this Tip?</div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteTip;
